import React from 'react';


export default function JobMatchingRippleEffect(props) {
    return (
        <div className="job-matching-circle-ripple">
            <div className="circle-ripple" id="Job-matching-circle-ripple"></div>
        </div >
    );
}